import { combineReducers } from 'redux';

import * as actionTypes from '../action-creator/actionTypes';

const graphColors = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOAD_GRAPH_COLORS_SUCCESS:
      return action.colors;
    default:
      return state;
  }
}

const loggedInUser = (state = null, action) => {
  switch (action.type) {
    case actionTypes.LOAD_USER_DATA_SUCCESS:
      return action.user;
    case actionTypes.LOGOUT_REQUEST:
      return null;
    default:
      return state;
  }
}

const userMQTTData = (state = null, action) => {
  switch (action.type) {
    case actionTypes.LOAD_USER_DATA_SUCCESS:
      return action.data;
    case actionTypes.LOGOUT_REQUEST:
      return null;
    default:
      return state;
  }
}

const validToken = (state = null, action) => {
  switch (action.type) {
    case actionTypes.REFRESH_TOKEN_SUCCESS:
      return action.message;
    case actionTypes.REFRESH_TOKEN_FAILURE:
      return action.message;
    default:
      return state;
  }
}

const isLoggingIn = (state = false, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      return true;
    case actionTypes.SHOW_INCORRECT_CREDENTIAL_MSG:
    case actionTypes.LOGIN_FAILURE:
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGOUT_REQUEST:
      return false;
    default:
      return state;
  }
}

const isRequestingOTP = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SEND_OPT_REQUEST:
      return true;
    case actionTypes.SEND_OPT_FAILURE:
    case actionTypes.SEND_OPT_SUCCESS:
      return false;
    default:
      return state;
  }
}

const isResettingPassword = (state = false, action) => {
  switch (action.type) {
    case actionTypes.RESET_PASSWORD_REQUEST:
      return true;
    case actionTypes.RESET_PASSWORD_FAILURE:
    case actionTypes.RESET_PASSWORD_SUCCESS:
      return false;
    default:
      return state;
  }
}

const userIdCheckingIntervalId = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_ID_CHECKING_INTERVAL_ID:
      return action.intervalId;
    default:
      return state;
  }
}

export default combineReducers({
  loggedInUser,
  isLoggingIn,
  isRequestingOTP,
  isResettingPassword,
  graphColors,
  userIdCheckingIntervalId,
  validToken,
  userMQTTData
});

const getSystemState = state => state.system;

export const getLoggedInUser = state => getSystemState(state).loggedInUser;

export const getuserMQTTData = state => getSystemState(state).userMQTTData;

export const getIsLoggingIn = state => getSystemState(state).isLoggingIn;

export const getIsRequestingOTP = state => getSystemState(state).isRequestingOTP;

export const getIsResettingPassword = state => getSystemState(state).isResettingPassword;

export const getGraphColors = state => getSystemState(state).graphColors;

export const getUserIdCheckingIntervalId = state => getSystemState(state).userIdCheckingIntervalId;

export const getValidToken = state => getSystemState(state).validToken;